import { render, staticRenderFns } from "./SIPBridge.vue?vue&type=template&id=60234d33&scoped=true"
import script from "./SIPBridge.vue?vue&type=script&lang=js"
export * from "./SIPBridge.vue?vue&type=script&lang=js"
import style0 from "./SIPBridge.vue?vue&type=style&index=0&id=60234d33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60234d33",
  null
  
)

export default component.exports